<template>
	<div class="">
		<Breadcrumb/>
		<div class="wrap">
			<div class="activity-form-wrap">
				<el-form :inline="true" class="activity-form">
					<el-form-item label="统计区域" v-if="tjFlag!=3">
						<el-select v-model="tjFlag" @change="setSelectedType">
							<el-option label="统计省" value="0"></el-option>
							<el-option label="统计市" value="1"></el-option>
							<el-option label="统计区县" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="活动名称">
						<el-input v-model="vacationName" disabled placeholder="请点击选择活动" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button size="mini" type="primary" @click="selectDialog">选择活动</el-button>
						<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearch">统计</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="toReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<el-button style="margin-bottom: 15px;" size="mini" type="primary" @click="toExport">导出Excel</el-button>
			<el-table border size="mini" @sort-change="sortChange" :default-sort="{prop: 'scope', order: 'joinNum'}" :data="dataList"
				style="width: 100%">
				<el-table-column prop="scope" sortable="custom" label="区域范围">
					<template slot-scope="scope">
						<div v-if="tjFlag!=3">
							<div v-if="tjFlag==0">{{scope.row.provinceName}}</div>
							<div v-if="tjFlag==1">{{scope.row.provinceName}} {{scope.row.cityName}}</div>
							<div v-if="tjFlag==2">{{scope.row.provinceName}} {{scope.row.cityName}} {{scope.row.districtName}}</div>
						</div>
						<div v-else>
							<span>{{scope.row.school}}</span>
						</div>

					</template>
				</el-table-column>
				<el-table-column prop="auditStatus0" sortable="custom" label="报名人数">
				</el-table-column>
				<el-table-column prop="joinStatus0" sortable="custom" label="入选人数">
				</el-table-column>
				<el-table-column prop="rxlStr" sortable="custom" label="入选率">
				</el-table-column>
				<el-table-column prop="finishStatus0" sortable="custom" label="完成人数">
				</el-table-column>
				<el-table-column prop="wclStr" sortable="custom" label="完成率">
				</el-table-column>
			</el-table>
			<Pagination :total="total" :pageSize="pageSize" @pageChange="handleCurrentChange" />
			<!--选择活动弹窗-->
			<el-dialog title="选择活动" :visible.sync="dialogVisible" width="70%" @click="dialogVisible=false">
				<el-form :inline="true" class="activity-form-wrap">
					<el-form-item label="活动名称">
						<el-input v-model="vacationName" placeholder="请输入活动名称" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" size="mini" type="primary" @click="toSearchActivity">搜索</el-button>
						<el-button icon="el-icon-refresh" size="mini" @click="toResetActivity">重置</el-button>
					</el-form-item>
				</el-form>
				<el-table  size="mini" border :data="activityList" style="width: 100%">
					<el-table-column prop="startCompayName" label="主办方" width="100">
					</el-table-column>
					<el-table-column prop="vacationName" label="活动名称">
					</el-table-column>
					<el-table-column prop="activityType" label="活动类型" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.activityType==0">包裹发放</span>
							<span v-else>最美推荐</span>
						</template>
					</el-table-column>
					<el-table-column label="招募范围" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.recruitType==0">全国</span>
							<span v-else>{{scope.row.recruitNames}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="recruitNums" label="招募人数" width="70">
					</el-table-column>
					<el-table-column prop="recruitTime" label="报名时间">
					</el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<span class="select-txt" @click="selectActivity(scope.row)">选择</span>
						</template>
					</el-table-column>
				</el-table>
				<Pagination :total="activityTotal" @pageChange="handleCurrentChange2"/>
			</el-dialog>
		</div>

	</div>

</template>

<script>
	import Title from '@/components/titleAdmin'
	import Pagination from '@/components/admin/pagination'
	import Breadcrumb from '@/components/admin/breadcrumb'
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'StatisticsArea',
		components: {
			Title,
			Pagination,
			Breadcrumb
		},
		data() {
			return {
				startCompanyId: '',
				vacationId: '',
				tjFlag: '0',
				sort: '',
				sortProp: '',
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dataList: [],
				activityTotal: 0,
				dialogVisible: false,
				vacationName: '',
				type: '',
				activityList: []
			}
		},
		watch: {
			$route(to, from) {
				this.tjFlag = this.$route.query.type
				this.pageNum = 1
				this.total = 0
				this.dataList = []
				this.sort = ''
				this.sortProp = ''
				this.vacationId = ''
				this.vacationName = ''
				this.getDataList()
			}
		},
		created() {
			this.startCompanyId = localStorage.getItem('companyId')
			this.tjFlag = this.$route.query.type
			this.getDataList()
		},
		methods: {
			//获取数据列表
			async getDataList() {
				let param = {
					startCompanyId: this.startCompanyId||'',
					vacationId: this.vacationId,
					tjFlag: this.tjFlag,
					sortRule: this.sort,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/joinStatusEnroll/list', qs.stringify(param))
				console.log(res.data.page.items)
				if (res.data.code == 200) {
					this.dataList = res.data.page.items
					this.total = res.data.page.count
				}
			},
			setSelectedType(e){
				this.tjFlag = e
				this.pageNum = 1
				this.total = 0
				this.dataList = []
				this.getDataList()
			},
			toSearch(){
				this.pageNum = 1
				this.total = 0
				this.getDataList()
			},
			toReset(){
				//this.tjFlag = this.type=='1'?'0':'3'
				this.vacationId = ''
				this.vacationName = ''
				this.pageNum = 1
				this.total = 0
				this.dataList = []
				this.getDataList()
			},
			selectDialog(){
				this.dialogVisible = true
				this.vacationId = ''
				this.vacationName = ''
				this.pageNum = 1
				this.activityTotal = 0
				this.getActivityList()
			},
			//获取活动列表
			async getActivityList(){
				let param = {
					startCompanyId: this.startCompanyId||'',
					vacationName: this.vacationName,
					auditStatus: 2,
					publishStatus: 1,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('admin/vacation/list', qs.stringify(param))
				if (res.data.code == 200) {
					this.activityList = res.data.page.items
					this.activityTotal = res.data.page.count
				}
			},
			toSearchActivity(){
				this.getActivityList()
			},
			toResetActivity(){
				this.vacationName = ''
				this.pageNum = 1
				this.activityTotal = 0
				this.getActivityList()
			},
			// 确认选择活动
			selectActivity(row){
				this.vacationId = row.id
				this.vacationName = row.vacationName
				this.dialogVisible = false
			},
			//分页
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			//分页
			handleCurrentChange2(e){
				this.activityList = []
				this.pageNum = e.number
				this.getActivityList()
			},
			//导出地址
			toExport(){
				let url = 'admin/joinStatusEnroll/downloadZdResult'
				let title = '确定导出统计数据吗？'
				this.$confirm(title,'温馨提示',{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let downUrl = config.baseUrl + url
					window.location.href = downUrl
				}).catch(() => {

				})
			},
			sortChange(column){
				let prop = column.prop
				console.log(column)
				if(this.sortProp!=column.prop) {
					this.pageNum = 1
					this.dataList = []
					this.total = 0
				}
				this.sortProp = column.prop
				if(column.order == 'ascending') {
					//升序
					if(prop =='scope') {
						this.sort = 'region:names_asc'
					} else if(prop =='auditStatus0') {
						this.sort = 'audit:status0_asc'
					} else if(prop =='joinStatus0') {
						this.sort = 'join:status0_asc'
					} else if(prop =='rxlStr') {
						this.sort = 'rxl:str_asc'
					} else if(prop =='finishStatus0') {
						this.sort = 'finish:status0_asc'
					} else if(prop =='wclStr') {
						this.sort = 'wcl:str_asc'
					}
				} else if(column.order == 'descending'){
					//降序
					if(prop =='scope') {
						this.sort = 'region:names_desc'
					} else if(prop =='auditStatus0') {
						this.sort = 'audit:status0_desc'
					} else if(prop =='joinStatus0') {
						this.sort = 'join:status0_desc'
					} else if(prop =='rxlStr') {
						this.sort = 'rxl:str_desc'
					} else if(prop =='finishStatus0') {
						this.sort = 'finish:status0_desc'
					} else if(prop =='wclStr') {
						this.sort = 'wcl:str_desc '
					}
				} else{
					this.sort = ''
				}
				
				this.getDataList()
			}
		}
	}
</script>

<style scoped lang="less">
	@import url("../../table.less");

	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}

	.activity-form-wrap {
		// margin-bottom: 15px;
	}
	.select-txt{
		color: #EB6B1B;
		cursor: pointer;
	}
	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .activity-form-wrap .el-input__inner {
		width: 160px;
		height: 30px;
		line-height: 30px;
		font-size: 12px !important;
	}

	/deep/ .el-button--primary {
		background: #EB6B1B;
		border-color: #EB6B1B;
	}

	/deep/ .el-button--mini,
	.el-button--mini.is-round {
		padding: 4px 8px;
	}

	/deep/ .el-button {
		font-size: 12px !important;
	}

	.manage-btns {
		color: #EB6B1B;

		span {
			cursor: pointer;
		}

		.space {
			margin: 0 5px;
			cursor: default;
		}
	}
</style>
